import {
  Component,
  OnDestroy,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { SubSink } from "subsink";

import { ConfigurationService } from "@/shared-module/services";
import { Configuration, LanguageChoice } from "@/shared-module/models";

@Component({
  selector: "app-languageselectiondialog",
  templateUrl: "languageselectiondialog.component.html",
  encapsulation: ViewEncapsulation.None,
  styles: [
    `
      .btn-validate {
        font-size: 10px;
        font-weight: bold;
        letter-spacing: 2px;
        padding: 12px 24px;
        background-color: #2d81ff;
        color: #ffffff;
        border-radius: 24px;
        margin-top: 16px;
        margin-right: 16px;
      }
      .btn-validate:disabled {
        background-color: #c9c9db;
      }
      .btn-validate {
        background-color: #ffffff;
        color: #00001f;
        border: 1px solid #c9c9db;
      }
    `,
  ],
})
export class LanguageSelectionDialogComponent implements OnDestroy {
  @ViewChild("template", { static: true }) template;
  @ViewChild("content", { static: true }) content;
  supportedLanguages: LanguageChoice[];
  subs = new SubSink();
  cssColor: string;
  selectedLanguageTexts: any;
  titleText: string;
  subTitleText: string;

  constructor(
    private configurationService: ConfigurationService,
    private modalService: NgbModal,
  ) {
    const thisObject = this;
    this.subs.sink = this.configurationService.config.subscribe(
      (c: Configuration) => {
        thisObject.cssColor = c.cssColor;
        thisObject.supportedLanguages = c.supportedLanguages;
        thisObject.titleText = c.languageTitleText;
        thisObject.subTitleText = c.languageSubTitleText;
      },
    );
  }

  selectLanguage(language) {
    this.configurationService.setLanguage(language).subscribe((s) => {
      location.reload();
    });
  }

  open() {
    this.modalService.open(this.content, {
      ariaLabelledBy: "modal-basic-title",
      windowClass: "modal-full modal-dialog-scrollable",
      size: "xl",
    });
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
